<template>
	<transition
		:mode="mode"
		name="collapse"
		@enter="enter"
		@after-enter="afterEnter"
		@before-leave="beforeLeave"
		@leave="leave"
	>
		<slot />
	</transition>
</template>
<script lang="ts">
export default {
	name: 'TransitionCollapse'
};
</script>
<script setup lang="ts">
interface Props {
	mode?: 'default' | 'in-out' | 'out-in' | undefined;
}

withDefaults(defineProps<Props>(), {
	mode: undefined
});

function enter(el: Element): void {
	const { height } = getComputedStyle(el);
	(el as HTMLElement).style.height = '0';
	setTimeout(() => {
		(el as HTMLElement).style.height = height;
	});
}

function afterEnter(el: Element): void {
	(el as HTMLElement).style.height = 'auto';
}

function beforeLeave(el: Element): void {
	const { height } = getComputedStyle(el);
	(el as HTMLElement).style.height = height;
}

function leave(el: Element): void {
	setTimeout(() => {
		(el as HTMLElement).style.height = '0';
	});
}
</script>
<style lang="scss" scoped>
$transition-duration: 350ms;
$transition-timing-function: cubic-bezier(0.5, 1, 0.89, 1);

.collapse-enter {
	opacity: 0;
}
.collapse-enter-active {
	opacity: 1;
	overflow: hidden;
	transition-duration: $transition-duration;
	transition-timing-function: $transition-timing-function;
}
.collapse-leave {
	opacity: 1;
}
.collapse-leave-active {
	opacity: 0;
	overflow: hidden;
	transition-duration: $transition-duration;
	transition-timing-function: $transition-timing-function;
}
</style>
